import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Subject, catchError, forkJoin, map, mergeMap, switchMap, tap, throwError } from 'rxjs';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiServiceService {
  public favoritesChanged: Subject<{ profileId: string, action: 'add' | 'remove' }> = new Subject();

  updateRequestStatus(id: any, arg1: string) {
    throw new Error('Method not implemented.');
  }

  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient, private router: Router) { }

  public handleQuotaError(error: any): boolean {
    const errObj = error?.error || error;
    if (errObj && (errObj.code === 'LIMIT_REACHED' || errObj.code === 'UPGRADE_REQUIRED' || error?.status === 403)) {
      const msgStr = String(errObj.message || '');
      const isChatError = msgStr.toLowerCase().includes('chat');
      const isFavError = msgStr.toLowerCase().includes('favorite') || msgStr.toLowerCase().includes('shortlist');
      const isFilterError = msgStr.toLowerCase().includes('filter') || msgStr.toLowerCase().includes('search');
      const isDiscoveryError = msgStr.toLowerCase().includes('discovery') || msgStr.toLowerCase().includes('daily') || msgStr.toLowerCase().includes('views');

      let title = '👑 Exclusive Benefits Access';
      if (isChatError) title = '💬 Chat Unavailable';
      else if (isFavError) title = '⭐ Shortlist Limit Reached';
      else if (isFilterError) title = '🏷️ Save Filter Feature';
      else if (isDiscoveryError) title = '🔍 Daily Discovery Limit Reached';

      let benefitBox = `<div style="margin-top: 12px; padding: 10px; background: #fffbeb; border: 1px solid #fef3c7; border-radius: 12px; font-size: 13px; color: #92400e;">
        <b>Member Benefit:</b> Upgrade to enjoy more benefits including verified direct contact numbers & full photo gallery discovery.
      </div>`;

      if (isChatError) {
        benefitBox = `<div style="margin-top: 14px; padding: 12px; background: #fef2f2; border: 1px solid #fecaca; border-radius: 12px; font-size: 13px; color: #991b1b; text-align: left;">
          <div style="display: flex; align-items: center; gap: 6px; font-weight: bold; margin-bottom: 4px;">
            🔒 Plan Restriction
          </div>
          Direct messaging is restricted because both profiles are currently on the Free tier. Upgrading either profile instantly unlocks live messaging.
        </div>`;
      } else if (isFavError) {
        benefitBox = `<div style="margin-top: 14px; padding: 12px; background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 12px; font-size: 13px; color: #1e3a8a; text-align: left;">
          <div style="display: flex; align-items: center; gap: 6px; font-weight: bold; margin-bottom: 4px;">
            ✨ Unlimited Shortlisting
          </div>
          Upgrade to Silver or Gold membership to save unlimited favorites and organize your top matches effortlessly!
        </div>`;
      } else if (isFilterError) {
        benefitBox = `<div style="margin-top: 14px; padding: 12px; background: #fffbeb; border: 1px solid #fde68a; border-radius: 12px; font-size: 13px; color: #92400e; text-align: left;">
          <div style="display: flex; align-items: center; gap: 6px; font-weight: bold; margin-bottom: 4px;">
            ⭐ Pro Member Feature
          </div>
          Upgrade your plan to save custom search criteria and quickly access your ideal partner filters anytime!
        </div>`;
      } else if (isDiscoveryError) {
        benefitBox = `<div style="margin-top: 14px; padding: 12px; background: #fdf2f8; border: 1px solid #fbcfe8; border-radius: 12px; font-size: 13px; color: #9d174d; text-align: left;">
          <div style="display: flex; align-items: center; gap: 6px; font-weight: bold; margin-bottom: 4px;">
            🚀 Expand Your Match Discovery
          </div>
          You have viewed your daily quota of profiles! Upgrade to Silver (50 views/day) or Gold (150 views/day) to continue exploring profiles immediately without waiting for tomorrow!
        </div>`;
      }

      Swal.fire({
        title: title,
        html: `<p style="font-size: 14px; color: #4b5563; line-height: 1.5; margin: 0;">${msgStr || 'Upgrade to unlock this feature!'}</p>
               ${benefitBox}`,
        icon: isChatError ? 'info' : 'warning',
        showCancelButton: true,
        confirmButtonText: isChatError ? 'Upgrade to Chat' : (isFavError ? 'Unlock Unlimited Favorites' : (isFilterError ? 'Upgrade to Save Filters' : (isDiscoveryError ? 'Upgrade Discovery Quota' : 'Upgrade for More Benefits'))),
        cancelButtonText: isChatError ? 'Close' : 'Maybe Later',
        confirmButtonColor: '#800020',
        cancelButtonColor: '#6c757d'
      }).then((result) => {
        if (result.isConfirmed) {
          this.router.navigate(['/plans']);
        }
      });
      return true;
    }
    return false;
  }

  getCitizenship(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/master/citizen`);
  }

  getCities(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/master/city`);
  }

  // createToken(): Observable<any> {
  //   return this.http.post<any>(`${this.apiUrl}/auth/create-token`, {});
  // }

  // signup(userData: any): Observable<any> {
  //   return this.http.post<any>(`${this.apiUrl}/auth/signup`, userData);
  // }

  createToken(): Observable<string> {
    const url = this.apiUrl + '/auth/create-token';
    return this.http.post<any>(url, {}).pipe(
      map(response => {
        if (response && response.data.access_token) {
          return response.data.access_token;
        } else {
          throw new Error('No access token');
        }
      }),
      catchError(error => {
        return throwError('Please try later...');
      })
    );
  }
  signup(userData: any): Observable<any> {
    userData.group = 'TEST';
    console.log(userData, 'userdata');

    return this.createToken().pipe(

      mergeMap((token: string) => {
        console.log(token, 'token');

        // Use the obtained token to make the signup request
        const headers = new HttpHeaders({
          'Content-Type': 'application/json',
          'authorization': token

        });
        console.log(headers, 'headers');
        return this.http.post<any>(`${this.apiUrl}/auth/signup`, userData, { headers });
      }),
      catchError(error => {
        return throwError('Please try later11...');
      })
    ).pipe(tap((response: any) => {
      const { profileId, sessionToken, uname } = response.data;
      this.storeSessionData(profileId, sessionToken, uname);
    })
    );
  }
  merchantRegister(merchantData: any): Observable<any> {

    return this.createToken().pipe(

      mergeMap((token: string) => {


        const headers = new HttpHeaders({

          // Do not add Content-Type here.
          // Browser will automatically set multipart/form-data boundary.

          'authorization': token

        });



        return this.http.post<any>(

          `${this.apiUrl}/merchant/register`,

          merchantData,

          {
            headers
          }

        );


      }),


      catchError(error => {


        return throwError(() => error);


      })


    );


  }
  merchantLogin(email: string, password: string): Observable<any> {

    const body = {
      email: email,
      password: password
    };

    return this.http.post<any>(
      `${this.apiUrl}/merchant/login`,
      body
    ).pipe(
      tap((response: any) => {

        console.log("Merchant Login Response", response);

        const {
          sessionToken,
          refreshToken,
          merchantId,
          business_name
        } = response.data;


        localStorage.setItem(
          "merchantToken",
          sessionToken
        );

        localStorage.setItem(
          "merchantId",
          merchantId
        );

        localStorage.setItem(
          "merchantName",
          business_name
        );

      })
    );

  }
  getMerchantProfile(merchantId: string) {
    return this.http.get<any>(
      `${this.apiUrl}/merchant/profile/${merchantId}`
    );
  }
  updateMerchantProfile(
    merchantId: string,
    merchantData: any
  ): Observable<any> {


    return this.http.put<any>(

      `${this.apiUrl}/merchant/profile/${merchantId}`,

      merchantData

    );


  }
  

  updateMerchantProfilePicture(merchantId: string, file: File) {
    const formData = new FormData();
    formData.append('profile_pic', file);

    return this.http.put<any>(
      `${this.apiUrl}/merchant/profile/${merchantId}/picture`,
      formData
    );
  }
  // ===============================
  // Merchant About Us
  // ===============================


  // Create / Update Merchant About

  saveMerchantAbout(
    merchantId: string,
    data: any
  ) {

    return this.http.post<any>(

      `${this.apiUrl}/merchant/about`,

      {
        merchantId: merchantId,
        story: data.story,
        speciality: data.speciality
      }

    );

  }



  // Get Merchant About

  getMerchantAbout(
    merchantId: string
  ) {

    return this.http.get<any>(

      `${this.apiUrl}/merchant/about/${merchantId}`

    );

  }




  getMerchantsByCategory(categoryId: string) {

    return this.http.get<any>(

      `${this.apiUrl}/merchant/category/${categoryId}`

    );

  }
  getMerchantDetails(id: string) {


    return this.http.get<any>(

      `${this.apiUrl}/merchant/profile/${id}`

    );


  }
  getServiceBookingCount(serviceId:any){
  return this.http.get<any>(
    this.apiUrl + '/bookings/service-count/' + serviceId
  );
}


  getServiceCategories() {

    return this.http.get<any>(

      `${this.apiUrl}/service-categories`

    );

  }
  // Add Merchant Service

  addMerchantService(serviceData: any) {

    return this.http.post<any>(
      `${this.apiUrl}/merchant/services`,
      serviceData
    );

  }



  // Get Merchant Services

  getMerchantServices(merchantId: string) {

    return this.http.get<any>(
      `${this.apiUrl}/merchant/services/${merchantId}`
    );

  }

  updateMerchantService(id: string, data: FormData) {

    return this.http.put<any>(
      `${this.apiUrl}/merchant/services/${id}`,
      data
    );

  }


  // Delete Merchant Service

  deleteMerchantService(serviceId: string) {

    return this.http.delete<any>(
      `${this.apiUrl}/merchant/services/${serviceId}`
    );

  }
  // Get Single Service Details

  getServiceDetails(id: string) {

    return this.http.get<any>(
      `${this.apiUrl}/merchant/services/details/${id}`
    );

  }
  
  // CREATE BLOCK DATE

  createBlockedDate(data: any) {

    return this.http.post(
      `${this.apiUrl}/merchant/blocked-date`,
      data
    );

  }



  // GET BLOCKED DATES
  getBlockedDates(merchantId: any) {

    return this.http.get(
      `${this.apiUrl}/merchant/blocked-dates/${merchantId}`
    );

  }



  // DELETE BLOCK DATE

  deleteBlockedDate(id: any) {

    return this.http.delete(

      `${this.apiUrl}/merchant/blocked-date/${id}`

    );

  }


  acceptBooking(id: any) {

    return this.http.put(

      this.apiUrl + '/bookings/accept/' + id,

      {}

    );

  }
  rejectBooking(id: any, reason: string) {

    return this.http.put(

      this.apiUrl + '/bookings/reject/' + id,

      {

        reject_reason: reason

      }

    );

  }
  markAdvancePaid(id:string){

return this.http.put<any>(

this.apiUrl +
'/bookings/advance-paid/' +
id,

{}

);

}



markFullyPaid(id:string){

return this.http.put<any>(

this.apiUrl +
'/bookings/fully-paid/' +
id,

{}

);

}






  createPayment(data: any) {

    return this.http.post<any>(

      this.apiUrl +
      '/merchant/payment/create',

      data

    );

  }
  getBookingById(id: any) {

    return this.http.get<any>(

      this.apiUrl +
      '/bookings/details/' +
      id

    );

  }

  // ===============================
  // BOOKING APIs
  // ===============================


  // CREATE BOOKING

  createBooking(data: any) {

    return this.http.post(
      `${this.apiUrl}/bookings/create`,
      data
    );

  }



  // GET USER BOOKINGS

  getUserBookings(email: string) {

    return this.http.get(
      `${this.apiUrl}/bookings/user/${email}`
    );

  }



  // GET MERCHANT BOOKINGS

  getMerchantBookings(merchantId: string) {

    return this.http.get(
      `${this.apiUrl}/bookings/merchant/${merchantId}`
    );

  }



  // GET BOOKING DETAILS

  getBookingDetails(bookingId: string) {

    return this.http.get(
      `${this.apiUrl}/bookings/${bookingId}`
    );

  }

  upgradeSubscription(merchantId: string, paymentData: any) {
    return this.http.patch(`${this.apiUrl}/merchant/${merchantId}/upgrade-subscription`, paymentData);
  }

  createRazorpayOrder(amount: number) {
    return this.http.post(`${this.apiUrl}/merchant-payment/create-order`, { amount });
  }

  getMerchantPlans() {
    return this.http.get(`${this.apiUrl}/merchant/plans`);
  }

  updateAdvertisement(merchantId: string, data: any) {
    return this.http.patch(`${this.apiUrl}/merchant/${merchantId}/advertisement`, data);
  }

  getActiveAdvertisements() {
    return this.http.get<any>(`${this.apiUrl}/merchant/advertisements/active`);
  }

  getPremiumVendors() {
    return this.http.get<any>(`${this.apiUrl}/merchant/premium`);
  }
  getCategoryVendorCounts() {
  return this.http.get(
    `${this.apiUrl}/merchant/category/vendor-count`
  );
}
getMerchantCities(): Observable<any> {
  return this.http.get(`${this.apiUrl}/merchant/cities`);
}



  // ===============================
  // PAYMENT APIs
  // ===============================



  // CREATE PAYMENT PREFERENCE

  createMerchantPayment(data: any) {

    return this.http.post(
      `${this.apiUrl}/merchant/payment/create`,
      data
    );

  }
  createMerchantPaymentOrder(data: any) {

    return this.http.post(
      `${this.apiUrl}/merchant/payment/create-order`,
      data
    );

  }



  // GET USER PAYMENTS

  getUserPayments(email: string) {

    return this.http.get(
      `${this.apiUrl}/merchant/payment/user/${email}`
    );

  }


  // COMPLETE ADVANCE PAYMENT

  completeAdvancePayment(bookingId: string) {

    return this.http.put(
      `${this.apiUrl}/merchant/payment/complete-advance/${bookingId}`,
      {}
    );

  }


  // GET MERCHANT PAYMENTS

  getMerchantPayments(merchantId: string) {

    return this.http.get(
      `${this.apiUrl}/merchant/payment/merchant/${merchantId}`
    );

  }





  // GET PAYMENT DETAILS

  getPaymentDetails(bookingId: string) {

    return this.http.get(
      `${this.apiUrl}/merchant-payment/${bookingId}`
    );

  }
  getTodayRevenue(merchantId: any) {

    return this.http.get<any>(

      this.apiUrl +
      '/merchant/revenue/today/' +
      merchantId

    );

  }



  getMonthlyRevenue(
    merchantId: any,
    year: any,
    month: any
  ) {

    return this.http.get<any>(

      this.apiUrl +
      '/merchant/revenue/month/' +
      merchantId +
      '/' +
      year +
      '/' +
      month

    );

  }



  getYearlyRevenue(
    merchantId: any,
    year: any
  ) {

    return this.http.get<any>(

      this.apiUrl +
      '/merchant/revenue/year/' +
      merchantId +
      '/' +
      year

    );

  }




  getTotalRevenue(merchantId: any) {

    return this.http.get<any>(

      this.apiUrl +
      '/merchant/revenue/total/' +
      merchantId

    );

  }
  getMonthlyChartRevenue(
    merchantId: any,
    year: any
  ) {

    return this.http.get<any>(

      this.apiUrl +
      '/merchant/revenue/monthly-chart/' +
      merchantId +
      '/' +
      year

    );

  }



  getYearlyChartRevenue(
    merchantId: any
  ) {

    return this.http.get<any>(

      this.apiUrl +
      '/merchant/revenue/yearly-chart/' +
      merchantId

    );

  }
  // =============================
  // MERCHANT ENQUIRY
  // =============================


  // User create enquiry
  createServiceEnquiry(data: any) {

    return this.http.post<any>(

      this.apiUrl + '/enquiry/create',

      data

    );

  }



  // User enquiries

  getUserEnquiries(userId: any) {

    return this.http.get<any>(

      this.apiUrl + '/enquiry/user/' + userId

    );

  }



  // Merchant enquiries

  getMerchantEnquiries(merchantId: any) {

    return this.http.get<any>(

      this.apiUrl + '/enquiry/merchant/' + merchantId

    );

  }



  // Reply enquiry

  replyServiceEnquiry(
    enquiryId: any,
    data: any
  ) {

    return this.http.post<any>(

      this.apiUrl + '/enquiry/' + enquiryId + '/reply',

      data

    );

  }
  markMerchantRead(id: any) {

    return this.http.put<any>(

      this.apiUrl + '/enquiry/' + id + '/read/merchant',

      {}

    );

  }



  markUserRead(id: any) {

    return this.http.put<any>(

      this.apiUrl + '/enquiry/' + id + '/read/user',

      {}

    );

  }
  closeServiceEnquiry(id: any) {

    return this.http.delete<any>(

      this.apiUrl + '/enquiry/' + id

    );

  }
  submitReligionData(requestData: any, sessionToken: string): Observable<any> {
    console.log(requestData, 'request');
    console.log(sessionToken, 'sessionToken');

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization': sessionToken
    });

    return this.http.post<any>(`${this.apiUrl}/profile_mgmt`, requestData, { headers });
  }

  updateProfile(requestData: any, sessionToken: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization': sessionToken
    });
    return this.http.post<any>(`${this.apiUrl}/profile_mgmt`, requestData, { headers });
  }
  // submitPersonalData(requestData: any, sessionToken: string): Observable<any> {
  //   console.log(requestData, 'requestpersonal');
  //   console.log(sessionToken, 'sessionTokenpersonal');

  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json',
  //     'authorization': sessionToken
  //   });

  //   return this.http.post<any>(`${this.apiUrl}/profile_mgmt`, requestData, { headers });
  // }
  submitPersonalData(formData: FormData, sessionToken: string): Observable<any> {
    const headers = new HttpHeaders({
      'authorization': sessionToken
    });

    return this.http.post<any>(`${this.apiUrl}/profile_mgmt`, formData, { headers });
  }
  // uploadImage(imageFile: File): Observable<any> {
  //   const formData = new FormData();
  //   formData.append('image', imageFile);

  //   return this.http.post<any>(`${this.apiUrl}/auth/upload-image`, formData);
  // }
  // uploadImage(profileId: string, file: File): Observable<any> {
  //   const formData: FormData = new FormData();
  //   formData.append('oryId', profileId);
  //   formData.append('image', file, file.name);

  //   console.log('Uploading image with data:', formData);

  //   return this.http.post(`${this.apiUrl}/auth/upload-image`, formData);
  // }

  // updateAvatar(sessionToken: string, profileId: string, payload: any): Observable<any> {
  //   return this.http.put<any>(`${this.apiUrl}/profile_mgmt/avatar/${profileId}`, payload, {
  //     headers: { 'Authorization': `Bearer ${sessionToken}` }
  //   });
  // }

  // uploadImage(profileId: string, file: File): Observable<any> {
  //   const formData: FormData = new FormData();
  //   formData.append('profileId', profileId);  // Ensure this matches backend expectation
  //   formData.append('image', file, file.name);  // Ensure 'image' key matches backend expectation
  // updateImage(base64Image: string, sessionToken: string, profileId: string) {
  //   return this.http.post(`${this.apiUrl}/profile_mgmt/avatar/${profileId}`, {
  //     sessionToken,
  //     profileId,
  //     base64Image
  //   });
  // }
  // updateImage(base64Image: string, sessionToken: string, profileId: string) {
  //   return this.http.post(`${this.apiUrl}/profile_mgmt/avatar/${profileId}`, {
  //     sessionToken,
  //     base64Image
  //   }, {
  //     headers: { 'Authorization': `Bearer ${sessionToken}` }
  //   });
  // }
  //   return this.http.post(`${this.apiUrl}/auth/upload-image`, formData);
  // }
  updateImage(file: File, sessionToken: string, profileId: string): Observable<any> {
    const formData = new FormData();
    formData.append('avatar', file); // Append file to FormData

    const headers = new HttpHeaders({
      'authorization': sessionToken
    });

    return this.http.put<any>(`${this.apiUrl}/profile_mgmt/avatar/${profileId}`, formData, {
      headers: headers
    });
  }

  uploadGalleryPhotos(profileId: string, files: File[]): Observable<any> {
    const formData = new FormData();
    files.forEach(file => formData.append('gallery_photos', file, file.name));
    return this.http.post<any>(`${this.apiUrl}/profile_mgmt/upload_gallery/${profileId}`, formData);
  }

  deleteGalleryPhoto(profileId: string, fileName: string): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/profile_mgmt/gallery_photo/${profileId}/${encodeURIComponent(fileName)}`);
  }


  // uploadImage(oryId: string, image: File): Observable<any> {
  //   const imageFormData = new FormData();
  //   imageFormData.append('oryId', oryId);
  //   imageFormData.append('image', image, image.name); // Ensure to pass file and filename

  //   return this.http.post<any>(`${this.apiUrl}/auth/upload-image`, imageFormData);
  // }

  // uploadImage(formData: FormData, profileId: string, sessionToken: string) {
  //   return this.http.post(`${this.apiUrl}/auth/upload-image`, formData);
  // }


  submitProfessionalData(requestData: any, sessionToken: string): Observable<any> {
    console.log(requestData, 'requestprofessional');
    console.log(sessionToken, 'sessionTokenprofessional');

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization': sessionToken
    });

    return this.http.post<any>(`${this.apiUrl}/profile_mgmt`, requestData, { headers });
  }


  login(email: string, password: string): Observable<any> {
    console.log(email, password);

    return this.createToken().pipe(
      mergeMap((token: string) => {
        const headers = new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': token
        });
        console.log(headers);


        const body = {
          email: email,
          password: password
        };
        console.log(body);


        return this.http.post<any>(`${this.apiUrl}/auth/login`, body, { headers });
      })
    ).pipe(tap((response: any) => {
      console.log('>>>', response?.data);
      if (response && response.status === 'success' && response.data && typeof response.data === 'object') {
        const { profileId, sessionToken, uname } = response.data;
        this.storeSessionData(profileId, sessionToken, uname);
      }
    })
    );
  }

  // GET MERCHANT PORTFOLIO

  getMerchantPortfolio(merchantId: string) {

    return this.http.get<any>(
      `${this.apiUrl}/merchant/portfolio/${merchantId}`
    );

  }

  getServicePortfolio(serviceId: string) {

    return this.http.get<any>(
      `${this.apiUrl}/merchant/portfolio/service/${serviceId}`
    );

  }





  // ADD PORTFOLIO ITEM

  addMerchantPortfolio(data: FormData) {

    return this.http.post<any>(
      `${this.apiUrl}/merchant/portfolio`,
      data
    );

  }





  // UPDATE PORTFOLIO ITEM WITH MEDIA SUPPORT

  updateMerchantPortfolio(
    id: string,
    data: FormData
  ) {

    return this.http.put<any>(
      `${this.apiUrl}/merchant/portfolio/${id}`,
      data
    );

  }





  // DELETE PORTFOLIO ITEM

  deleteMerchantPortfolio(id: string) {

    return this.http.delete<any>(
      `${this.apiUrl}/merchant/portfolio/${id}`
    );

  }
  // GET MERCHANT CONVERSATIONS

  getMerchantConversations(merchantId: string) {

    return this.http.get<any>(
      `${this.apiUrl}/merchant/messages/conversations/${merchantId}`
    );

  }



  // GET MESSAGES

  getMerchantMessages(conversationId: string) {

    return this.http.get<any>(
      `${this.apiUrl}/merchant/messages/${conversationId}`
    );

  }



  // SEND MESSAGE

  sendMerchantMessage(data: any) {

    return this.http.post<any>(
      `${this.apiUrl}/merchant/messages/send`,
      data
    );

  }



  // MARK READ

  markMerchantMessagesRead(conversationId: string) {

    return this.http.put<any>(
      `${this.apiUrl}/merchant/messages/read/${conversationId}`,
      {}
    );

  }

  storeSessionData(profileId: string, sessionToken: string, uname: string): void {
    localStorage.setItem('profileId', profileId);
    localStorage.setItem('sessionToken', sessionToken);
    localStorage.setItem('uname', uname);
  }


  getEditProfile(requestData: any, sessionToken: string): Observable<any> {
    console.log(sessionToken, 'sessionEditProfile');

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization': sessionToken
    });

    return this.http.post<any>(`${this.apiUrl}/profile_mgmt`, requestData, { headers });
  }

  getEditDetails(sessionToken: string, profileId: string): Observable<any> {
    console.log(sessionToken, 'session');
    console.log(profileId, 'profileid');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization': sessionToken
    });
    return this.http.get<any>(`${this.apiUrl}/profile_mgmt/info/${profileId}`, { headers })
      .pipe(
        catchError(error => {
          console.error('Error fetching profile details:', error);
          return throwError(error);
        })
      );
  }

  getProfileDetails(sessionToken: string, profileId: string, userId?: any): Observable<any> {
    console.log(sessionToken, 'session');
    console.log(profileId, 'profileid');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization': sessionToken
    });
    return this.http.get<any>(`${this.apiUrl}/matches/profile_info/${profileId}/${userId}`, { headers })
      .pipe(
        catchError(error => {
          console.error('Error fetching profile details:', error);
          return throwError(error);
        })
      );
  }

  getConnectionStatus(sessionToken: string, ownerId: string, selectedProfileId: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization': sessionToken
    });
    return this.http.get<any>(`${this.apiUrl}/matches/connection_status/${ownerId}/${selectedProfileId}`, { headers })
      .pipe(
        catchError(error => {
          console.error('Error fetching connection status:', error);
          return throwError(error);
        })
      );
  }

  getPartner(requestData: any, sessionToken: string): Observable<any> {
    console.log(sessionToken, 'sessionEditProfile');

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization': sessionToken
    });

    return this.http.post<any>(`${this.apiUrl}/partnr_pref`, requestData, { headers });
  }
  getPartnerDetails(sessionToken: string, profileId: string): Observable<any> {
    console.log(sessionToken, 'session');
    console.log(profileId, 'profileid');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization': sessionToken
    });
    return this.http.get<any>(`${this.apiUrl}/partnr_pref/${profileId}`, { headers })
      .pipe(
        catchError(error => {
          console.error('Error fetching profile details:', error);
          return throwError(error);
        })
      );
  }

  // setConnectionStatus(sessionToken: string, profileId: string, interestStatus: string): Observable<any> {
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json',
  //     'authorization': sessionToken
  //   });

  //   const requestData = {
  //     owner_id: profileId,
  //     selected_profile_id: profileId,
  //     interest_status: interestStatus
  //   };

  //   return this.http.post<any>(`${this.apiUrl}/matches/set_connection_status`, requestData, { headers });
  // }

  setConnectionStatus(sessionToken: string, ownerId: any, selectedProfileId: any, interestStatus: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization': sessionToken
    });

    const requestData = {
      owner_id: ownerId,
      selected_profile_id: selectedProfileId,
      interest_status: interestStatus
    };
    console.log(requestData, 'req');
    console.log(headers, 'hed');


    return this.http.post<any>(`${this.apiUrl}/matches/set_connection_status`, requestData, { headers });
  }

  updateConnectionStatus(sessionToken: string, ownerId: any, selectedProfileId: any, interestStatus: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization': sessionToken
    });

    const requestData = {
      owner_id: ownerId,
      selected_profile_id: selectedProfileId,
      interest_status: interestStatus
    };

    return this.http.put<any>(`${this.apiUrl}/matches/set_connection_status`, requestData, { headers });
  }



  getSentConnectionList(sessionToken: string, profileId: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization': sessionToken
    });

    return this.http.get<any>(`${this.apiUrl}/matches/sent_connection_list/${profileId}`, { headers });
  }

  getReceivedConnectionList(sessionToken: string, profileId: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization': sessionToken
    });

    return this.http.get<any>(`${this.apiUrl}/matches/received_connection_list/${profileId}`, { headers });
  }

  getfilterMatches(sessionToken: string, requestData: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization': sessionToken
    });
    // const options = { headers: headers, body: requestBody };
    return this.http.post<any>(`${this.apiUrl}/matches/filter`, requestData, { headers });
  }
  getDivorcedProfiles(token: any) {

    return this.http.get<any>(
      this.apiUrl + '/matches/divorced',
      {
        headers: {
          Authorization: token
        }
      }
    );

  }
  // getReligionIdAndCasteIdAndFilterMatches(sessionToken: string): Observable<any> {
  //   return forkJoin({
  //     religions: this.getReligions(),
  //     castes: this.getCastes()
  //   }).pipe(
  //     switchMap(({ religions,castes }) => {
  //       const religionId = religions.id; // Assuming you want to use the first religion's ID
  //        const casteId = castes.id; // Assuming you want to use the first caste's ID
  //       const requestBody = { religion_id: religionId,caste_id: casteId }; //,
  //       return this.getfilterMatches(sessionToken, requestBody);
  //     })
  //   );
  // }
  getsaveFilter(sessionToken: string, requestData: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization': sessionToken
    });
    // const options = { headers: headers, body: requestBody };
    return this.http.post<any>(`${this.apiUrl}/matches/save_filter`, requestData, { headers });
  }

  getPreferenceFilter(sessionToken: string, profileId: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization': sessionToken
    });

    return this.http.get<any>(`${this.apiUrl}/partnr_pref/filter/${profileId}`, { headers });
  }

  getCategoryDiscoveryMatches(sessionToken: string, profileId: string, category: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization': sessionToken
    });

    return this.http.get<any>(`${this.apiUrl}/matches/discover_category/${encodeURIComponent(category)}/${profileId}`, { headers });
  }

  getSaveFilters(sessionToken: string, profileId: string): Observable<any> {
    console.log(sessionToken, 'session');
    console.log(profileId, 'profileid');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization': sessionToken
    });
    return this.http.get<any>(`${this.apiUrl}/matches/filter_list/${profileId}`, { headers })
      .pipe(
        catchError(error => {
          console.error('Error fetching profile details:', error);
          return throwError(error);
        })
      );
  }

  deleteFilter(sessionToken: string, filterId: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization': sessionToken
    });
    return this.http.delete<any>(`${this.apiUrl}/matches/delete_filter/${filterId}`, { headers })
      .pipe(
        catchError(error => {
          console.error('Error deleting filter:', error);
          return throwError(error);
        })
      );
  }

  updateFilter(sessionToken: string, filterId: string, payload: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization': sessionToken
    });
    return this.http.put<any>(`${this.apiUrl}/matches/update_filter/${filterId}`, payload, { headers })
      .pipe(
        catchError(error => {
          console.error('Error updating filter:', error);
          return throwError(error);
        })
      );
  }


  contactEnquiry(contactData: any): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this.http.post<any>(`${this.apiUrl}/enquiry/contact`, contactData, { headers });
  }
  // getfilterMatches(sessionToken: string): Observable<any> {
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json',
  //     'authorization': sessionToken
  //   });

  //   return forkJoin([
  //     this.getReligions(),
  //     this.getCastes()
  //   ]).pipe(
  //     mergeMap(([religions, castes]) => {
  //       const body = {
  //         religion_id: religions.religion._id,
  //         caste_id: castes.caste._id
  //       };

  //       const options = { headers: headers, body: body };

  //       return this.http.post<any>(`${this.apiUrl}/matches/filter`, {}, options).pipe(
  //         catchError(error => {
  //           throw error;
  //         })
  //       );
  //     })
  //   );
  // }


  // getfilterMatches(sessionToken: string, requestBody: any): Observable<any> {
  //   console.log(sessionToken, 'session');
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json',
  //     'authorization': sessionToken
  //   });
  //   console.log(headers);

  //   // const body = {
  //   //   religion_id: religionId,
  //   //   caste_id: casteId
  //   // };
  //   const options = {
  //     headers: headers,
  //     // Pass the requestBody as part of the options object
  //     body: requestBody
  //   };
  //   console.log(options,'op');

  //   const body = {
  //     religion_id: this.getReligions()
  //     // caste_id: "660403b190866710591f5ee3"
  //   };
  //   return this.http.post<any>(`${this.apiUrl}/matches/filter`, body, options);
  // }
  // getReligionIdAndCasteIdAndFilterMatches(sessionToken: string): Observable<any> {
  //   return forkJoin({
  //     religions: this.getReligions(),
  //     castes: this.getCastes()
  //   }).pipe(
  //     switchMap(({ religions, castes }) => {
  //       const religionId = religions[0].id; // Assuming your response structure
  //       const casteId = castes[0].id; // Assuming your response structure
  //       const requestBody = { religion_id: religionId, caste_id: casteId };
  //       return this.getfilterMatches(sessionToken, requestBody);
  //     })
  //   );
  // }
  getLocalToken() {
    return localStorage.getItem('sessionToken');
  }
  getReligions(): Observable<any> {
    const token = this.getLocalToken();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization': `${token}`

    });
    return this.http.get<any>(`${this.apiUrl}/master/religion`, { headers: headers });
  }
  getLanguages(): Observable<any> {
    const token = this.getLocalToken();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization': `${token}`

    });
    return this.http.get<any>(`${this.apiUrl}/master/lang`, { headers: headers });
  }
  getCitizens(): Observable<any> {
    const token = this.getLocalToken();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization': `${token}`

    });
    return this.http.get<any>(`${this.apiUrl}/master/citizen`, { headers: headers });
  }
  getCastes(): Observable<any> {
    const token = this.getLocalToken();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization': `${token}`

    });
    return this.http.get<any>(`${this.apiUrl}/master/caste`, { headers: headers })
  }
  getSubCastes(): Observable<any> {
    const token = this.getLocalToken();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization': `${token}`

    });
    return this.http.get<any>(`${this.apiUrl}/master/subcaste`, { headers: headers })
  }
  getGothrams(): Observable<any> {
    const token = this.getLocalToken();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization': `${token}`

    });
    return this.http.get<any>(`${this.apiUrl}/master/gothram`, { headers: headers })
  }
  getRasi(): Observable<any> {
    const token = this.getLocalToken();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization': `${token}`

    });
    return this.http.get<any>(`${this.apiUrl}/master/rasi`, { headers: headers })
  }
  getNatchra(): Observable<any> {
    const token = this.getLocalToken();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization': `${token}`

    });
    return this.http.get<any>(`${this.apiUrl}/master/natchra`, { headers: headers })
  }
  getEducation(): Observable<any> {
    const token = this.getLocalToken();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization': `${token}`

    });
    return this.http.get<any>(`${this.apiUrl}/master/education`, { headers: headers })
  }
  getHigherEducation(): Observable<any> {
    const token = this.getLocalToken();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization': `${token}`

    });
    return this.http.get<any>(`${this.apiUrl}/master/higher_education`, { headers: headers })
  }
  getEmploymentType(): Observable<any> {
    const token = this.getLocalToken();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization': `${token}`

    });
    return this.http.get<any>(`${this.apiUrl}/master/employment_type`, { headers: headers })
  }
  getOccupation(): Observable<any> {
    const token = this.getLocalToken();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization': `${token}`

    });
    return this.http.get<any>(`${this.apiUrl}/master/occupation`, { headers: headers })
  }
  getIncome(): Observable<any> {
    const token = this.getLocalToken();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization': `${token}`

    });
    return this.http.get<any>(`${this.apiUrl}/master/income`, { headers: headers })
  }
  getCity(): Observable<any> {
    const token = this.getLocalToken();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization': `${token}`

    });
    return this.http.get<any>(`${this.apiUrl}/master/city`, { headers: headers })
  }
  getDistrict(): Observable<any> {
    const token = this.getLocalToken();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization': `${token}`

    });
    return this.http.get<any>(`${this.apiUrl}/master/district`, { headers: headers })
  }
  getState(): Observable<any> {
    const token = this.getLocalToken();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization': `${token}`

    });
    return this.http.get<any>(`${this.apiUrl}/master/state`, { headers: headers })
  }
  // getCountry(): Observable<any> {
  //   const token = this.getLocalToken();
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json',
  //     'authorization': `${token}`

  //   });
  //   return this.http.get<any>(`${this.apiUrl}/master/countries`, { headers: headers })
  // }
  getTaluk(): Observable<any> {
    const token = this.getLocalToken();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization': `${token}`
    });
    return this.http.get<any>(`${this.apiUrl}/master/taluk`, { headers });
  }
  getCountry(): Observable<any> {

    const headers = this.createHeaders();
    return this.http.get<any>(`${this.apiUrl}/master/countries`, { headers });
  }

  getStateByCountry(cnty_id: string): Observable<any> {
    const headers = this.createHeaders();
    return this.http.get<any>(`${this.apiUrl}/master/states_by_country`, { headers, params: { cnty_id } });
  }

  getDistrictByState(stat_id: string): Observable<any> {
    const headers = this.createHeaders();
    return this.http.get<any>(`${this.apiUrl}/master/districts_by_state`, { headers, params: { stat_id } });
  }

  getTalukByDistrict(dist_id: string): Observable<any> {
    const headers = this.createHeaders();
    return this.http.get<any>(`${this.apiUrl}/master/taluks_by_district`, { headers, params: { dist_id } });
  }

  private createHeaders(): HttpHeaders {
    const token = localStorage.getItem('token') || '';
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization': `${token}`
    });
  }
  getEducationTypes(): Observable<any> {
    const token = this.getLocalToken();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization': `${token}`

    });
    return this.http.get<any>(`${this.apiUrl}/master/education_type`, { headers: headers })
  }
  getEducationByType(educationType: string): Observable<any> {
    const token = this.getLocalToken();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization': `${token}`
    });

    const params = { educationType };

    return this.http.get<any>(`${this.apiUrl}/master/education_by_type`, { headers, params });
  }
  getUniversity(): Observable<any> {
    const token = this.getLocalToken();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization': `${token}`

    });
    return this.http.get<any>(`${this.apiUrl}/master/eduuniversity`, { headers: headers })
  }
  getInstitution(): Observable<any> {
    const token = this.getLocalToken();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization': `${token}`

    });
    return this.http.get<any>(`${this.apiUrl}/master/eduinstitution`, { headers: headers })
  }


  getImage(imagePath: string): Observable<Blob> {
    const url = `${this.apiUrl}/auth/image/${imagePath}`
    // return this.http.get(`${this.apiUrl}/${key}`, { responseType: 'blob' });
    return this.http.get(url, { responseType: 'blob' });
  }
  // getImage(imagePath: string) {
  //   // This URL should match the one you set up in your backend
  //   const url = `http://localhost:8080/api/v1.0/auth/image/${imagePath}`;
  //   return this.http.get(url, { responseType: 'blob' });
  // }
  // getImage(imagePath: string) {
  //   const url = `http://localhost:8080/api/v1.0/auth/image/${imagePath}`;
  //   return this.http.get(url, { responseType: 'blob' });
  // }
  // getImage(imagePath: string): Observable<Blob> {
  //   return this.http.get(`${this.apiUrl}/${imagePath}`, { responseType: 'blob' });
  // }
  getUserProfile(oryId: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/auth/user-profile/${oryId}`);
  }
  // getTermsAndConditions() {
  //   return this.http.get(`${this.apiUrl}/cms/terms_condition`)
  // }
  // getPrivacyAndSecurity() {
  //   return this.http.get(`${this.apiUrl}/cms/privacy_security`)
  // }
  getTermsAndConditions() {
    return this.http.get(`${this.apiUrl}/cms/terms_condition`)
    // .pipe(
    //   map((response: any) => {
    //     return response.data;
    //   }),
    //   catchError((error) => {
    //     throw 'Error fetching terms and conditions: ' + error;
    //   })
    // );
  }

  getPrivacyAndSecurity() {
    return this.http.get(`${this.apiUrl}/cms/privacy_security`)
    // .pipe(
    //   map((response: any) => {
    //     return response.data;
    //   }),
    //   catchError((error) => {
    //     throw 'Error fetching privacy and security: ' + error;
    //   })
    // );
  }
  getFAQs() {
    return this.http.get(`${this.apiUrl}/cms/faq`)


  }

  getFaqs(): Observable<any> {
    return this.http.get(`${this.apiUrl}/faqs`);
  }

  // private baseurl=`http://localhost:8080`;
  // getImages(imageName: string): Observable<Blob> {


  //   return this.http.get(`${this.baseurl}/images/${imageName}`, { responseType: 'blob' });
  // }
  // getImagesList(): Observable<string[]> {
  //   return this.http.get<string[]>(`${this.baseurl}/api/images`);
  // }
  getImageBase64(imagePath: string): Observable<any> {
    const url = `${this.apiUrl}/auth/image/${imagePath}`
    // return this.http.get(`${this.apiUrl}/${key}`, { responseType: 'blob' });
    return this.http.get(url);
  }
  //  getConversation(senderId: string, receiverId: string): Observable<any> {
  //   return this.http.get<any>(`${this.apiUrl}/matches/get_conversation/${senderId}/${receiverId}`);
  // }
  sendMessage(sender_id: string, receiver_id: string, content: string): Observable<any> {
    const payload = {
      sender_id,
      receiver_id,
      content
    };
    return this.http.post(`${this.apiUrl}/matches/send_message`, payload);
  }
  // sendMessage(senderId: string, receiverId: string, message: string): Observable<any> {
  //   return this.http.post<any>(`${this.apiUrl}/matches/send_message`, { senderId, receiverId, message });
  // }
  getConversation(senderId: string, receiverId: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/matches/get_conversation/${senderId}/${receiverId}`);
  }

  getGlobalUnreadMessageCount(profileId: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/matches/unread_message_count/${profileId}`);
  }

  sendHeartbeat(profileId: string): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/profile_mgmt/heartbeat/${profileId}`, {});
  }

  getPresence(profileIds: string[]): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/profile_mgmt/presence`, { profileIds });
  }

  uploadHoroscope(profileId: string, formData: FormData): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/profile_mgmt/horoscope/${profileId}`, formData);
  }

  uploadAadhaar(profileId: string, formData: FormData): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/profile_mgmt/aadhaar/${profileId}`, formData);
  }

  reportProfile(profileId: string, payload: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/profile_mgmt/report/${profileId}`, payload);
  }

  downloadBiodataPdf(profileId: string, requesterId: string): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/profile_mgmt/biodata/${profileId}?requesterId=${requesterId}`, { responseType: 'blob' });
  }

  markMessagesRead(sender_id: string, receiver_id: string): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/matches/mark_messages_read`, { sender_id, receiver_id });
  }

  sendContactForm(contactData: { name: string, email: string, phoneNo: string, message: string }): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/enquiry/contact`, contactData);
  }

  addToFavorites(sessionToken: string, profileId: string, ownerProfileId: string, basicInfo: any, religionInfo: any): Observable<any> {
    // Sanitize incoming objects to avoid sending malformed types (e.g. masked mobile strings)
    const sanitizeId = (val: any) => {
      if (!val && val !== 0) return null;
      if (typeof val === 'object' && val._id) return val._id;
      if (typeof val === 'string' && /^[a-f\d]{24}$/i.test(val)) return val;
      return null;
    };

    const sanitizedBasic: any = {
      first_name: basicInfo?.first_name || '',
      last_name: basicInfo?.last_name || '',
      // keep only digits for mobile; if none, set null
      mobile: (() => {
        const m = basicInfo?.mobile ? String(basicInfo.mobile) : '';
        const digits = m.replace(/\D+/g, '');
        return digits ? Number(digits) : null;
      })(),
      email: basicInfo?.email || null,
      date_of_birth: basicInfo?.date_of_birth || null,
      gender: basicInfo?.gender || null,
      mother_lang_id: sanitizeId(basicInfo?.mother_lang_id) || null,
      keycloak_id: basicInfo?.keycloak_id || null
    };

    const sanitizedReligion: any = {
      religion_id: sanitizeId(religionInfo?.religion_id) || null,
      caste_id: sanitizeId(religionInfo?.caste_id) || null,
      sub_caste_id: sanitizeId(religionInfo?.sub_caste_id) || null,
      gothrm_id: sanitizeId(religionInfo?.gothrm_id) || null,
      dosham: religionInfo?.dosham || null,
      natchr_id: sanitizeId(religionInfo?.natchr_id) || null,
      rasi_id: sanitizeId(religionInfo?.rasi_id) || null
    };

    const data = {
      profileId,
      ownerProfileId,
      basic_info: sanitizedBasic,
      religion_info: sanitizedReligion
    };
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization': sessionToken
    });

    return this.http.post(`${this.apiUrl}/matches/favourite`, data, { headers });
  }

  getFavorites(sessionToken: string, ownerProfileId: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': sessionToken
    });

    return this.http.get<any>(`${this.apiUrl}/matches/favourite?ownerProfileId=${ownerProfileId}`, { headers });
  }

  deleteFavorite(sessionToken: string, profileId: string, ownerProfileId: string) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization': sessionToken
    });
    return this.http.delete<any>(`${this.apiUrl}/matches/delete-favorite/${profileId}?ownerProfileId=${ownerProfileId}`, { headers })
      .pipe(
        catchError(error => {
          console.error('Error deleting filter:', error);
          return throwError(error);
        })
      );
  }
  shortlistMerchant(
  ownerProfileId: string,
  merchantId: string
): Observable<any> {

  const data = {
    ownerProfileId,
    merchantId
  };

  return this.http.post(
    `${this.apiUrl}/merchant/shortlist`,
    data
  );
}


getShortlistedMerchants(
  ownerProfileId: string
): Observable<any> {

  return this.http.get(
    `${this.apiUrl}/merchant/shortlisted?ownerProfileId=${ownerProfileId}`
  );
}


removeShortlistedMerchant(
  ownerProfileId: string,
  merchantId: string
): Observable<any> {

  return this.http.delete(
    `${this.apiUrl}/merchant/shortlist/${merchantId}?ownerProfileId=${ownerProfileId}`
  );
}


  getSentInterests(sessionToken: string, profileId: string): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'authorization': sessionToken });
    return this.http.get<any>(`${this.apiUrl}/matches/sent_connection_list/${profileId}`, { headers });
  }

  getReceivedInterests(sessionToken: string, profileId: string): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'authorization': sessionToken });
    return this.http.get<any>(`${this.apiUrl}/matches/received_connection_list/${profileId}`, { headers });
  }

  getUnreadInterestCount(sessionToken: string, profileId: string): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'authorization': sessionToken });
    return this.http.get<any>(`${this.apiUrl}/matches/unread_interest_count/${profileId}`, { headers });
  }

  markInterestsRead(sessionToken: string, profileId: string): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'authorization': sessionToken });
    return this.http.post<any>(`${this.apiUrl}/matches/mark_interests_read/${profileId}`, {}, { headers });
  }

  getNotifications(sessionToken: string, profileId: string): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'authorization': sessionToken });
    return this.http.get<any>(`${this.apiUrl}/profile_mgmt/notifications/${profileId}`, { headers });
  }

  markNotificationsRead(sessionToken: string, profileId: string): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'authorization': sessionToken });
    return this.http.post<any>(`${this.apiUrl}/profile_mgmt/mark_notifications_read/${profileId}`, {}, { headers });
  }

  // ─── Support Tickets (User) ─────────────────────────────────────────────
  createSupportTicket(data: { profileId: string; subject: string; category: string; message: string; screenshot_url?: string | null }): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/support/tickets`, data);
  }

  getUserTickets(profileId: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/support/tickets/my/${profileId}`);
  }

  getTicketById(ticketId: string, profileId: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/support/tickets/${ticketId}?profileId=${profileId}`);
  }

  addTicketReply(ticketId: string, profileId: string, message: string): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/support/tickets/${ticketId}/reply`, { profileId, message });
  }

  closeTicket(ticketId: string, profileId: string): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/support/tickets/${ticketId}/close`, { profileId });
  }

  getTicketUnreadCount(profileId: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/support/tickets/unread/${profileId}`);
  }

  // ─── OTP ─────────────────────────────────────────────────────────────────
  sendOtp(mobile: string, channel: 'sms' | 'whatsapp' = 'sms'): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/auth/send-otp`, { mobile, channel });
  }

  verifyOtp(mobile: string, otp: string): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/auth/verify-otp`, { mobile, otp });
  }

  getCityByDistrict(distId: string) {
    return this.http.get<any>(
      `${this.apiUrl}/master/cities_by_district?dist_id=${distId}`
    );
  }

  // ─── Leads ───────────────────────────────────────────────────────────────
  postLead(data: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/leads`, data);
  }

  getLeadsForMerchant(merchantId: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/leads/merchant/${merchantId}`);
  }

  requestForgotPasswordOtp(email: string): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/auth/forgot-password/request-otp`, { email });
  }

  resetPasswordWithOtp(email: string, otp: string, password: string): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/auth/forgot-password/reset`, { email, otp, password });
  }
  merchantForgotPassword(email:string):Observable<any>{

return this.http.post<any>(
`${this.apiUrl}/merchant/forgot-password`,
{
    email
});

}



merchantResetPassword(
email:string,
otp:string,
password:string
):Observable<any>{

return this.http.post<any>(
`${this.apiUrl}/merchant/reset-password`,
{
    email,
    otp,
    password
});

}
}
